// app/javascript/landing/sections/WorkProcessSection.tsx
import React from "react";
import { motion, Transition, Variants } from "framer-motion";

const transition: Transition = { duration: 1, ease: [0.25, 0.1, 0.25, 1] };
const variants: Variants = {
  hidden: { filter: "blur(10px)", y: 20, opacity: 0 },
  visible: { filter: "blur(0)", y: 0, opacity: 1 },
};

export function WorkProcessSection() {
  return (
    <motion.section
      className="x-bg-red-400 flex flex-col items-center justify-center"
      initial="hidden"
      whileInView="visible"
      transition={{ staggerChildren: 0.1 }}
    >
      <div className="max-w-5xl mx-auto px-4 space-y-12">
        {/* Títulos */}
        <div className="text-center space-y-1">
          <motion.h2
            className="text-4xl md:text-5xl font-bold text-purple-3"
            transition={transition}
            variants={variants}
          >
            Nuestro proceso de trabajo
          </motion.h2>
        </div>

        {/* Imagen del proceso */}
        <motion.div variants={variants} className="flex justify-center">
          <img
            src="/landing/workflow/proceso-trabajo.png" // ← ajusta aquí el PNG
            alt="Proceso de trabajo"
            className="max-w-5xl w-full h-auto"
          />
        </motion.div>
      </div>
    </motion.section>
  );
}
